import { AppThemePreset } from './theme-preset';

export const primeNGConfig = {
	ripple: true,
	translation: {
		dayNames: [
			'Domingo',
			'Segunda',
			'Terça',
			'Quarta',
			'Quinta',
			'Sexta',
			'Sábado',
		],
		dayNamesShort: [
			'Dom',
			'Seg',
			'Ter',
			'Qua',
			'Qui',
			'Sex',
			'Sáb',
		],
		dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
		monthNames: [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		],
		monthNamesShort: [
			'Jan',
			'Fev',
			'Mar',
			'Abr',
			'Mai',
			'Jun',
			'Jul',
			'Ago',
			'Set',
			'Out',
			'Nov',
			'Dez',
		],
		today: 'Hoje',
		clear: 'Limpar',
		dateFormat: 'dd/mm/yy',
		firstDayOfWeek: 0,
	},
	theme: {
		preset: AppThemePreset,
		options: {
			darkModeSelector: false,

		},
	},
};
